import { render, staticRenderFns } from "./fieldPreview.vue?vue&type=template&id=0c488f90&scoped=true"
import script from "./fieldPreview.vue?vue&type=script&lang=js"
export * from "./fieldPreview.vue?vue&type=script&lang=js"
import style0 from "./fieldPreview.vue?vue&type=style&index=0&id=0c488f90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c488f90",
  null
  
)

export default component.exports